<template>
	<div>
		<div style="padding: 0 15px 0;">
			<el-row class="right-box-row">
				<el-row class="right-box-row-title">
					<el-col :span="20">
						{{tableTitle}}
					</el-col>
					<el-col :span="4" style="color: #333333;font-size: 14px;font-weight:100;">
						点击量:{{pv.clickNum}}次
					</el-col>
				</el-row>
				<el-row :gutter="20" style="margin-top: 20px;">
					<el-col :span="6">
						<img src="@/assets/images/zltszhfw/ylqxcx/title_jyzz.jpg" style="width: 100%;" />
					</el-col>
					<el-col :span="18">
						<div v-for="jyzz in jyzzList" class="page-text">
							<div style="font-size: 15pt;font-weight:bold">
								<span>{{jyzz.jyzxName}}</span>
							</div>
							<div style="padding-top: 10px;">联系人：{{jyzz.contact}}</div>
							<div>地址：{{jyzz.deptAddr}}</div>
							<div>介绍：{{jyzz.jyzxContent}}</div>
						</div>
					</el-col>
				</el-row>
			</el-row>
		</div>

		<!-- 导航栏 -->

		<el-row>

			<el-col :span="24" style="padding-left: 15px">
				<div>
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="检测能力" name="first"></el-tab-pane>
						<el-tab-pane label="设备介绍" name="second"></el-tab-pane>
						<el-tab-pane label="资质证书" name="third"></el-tab-pane>
					</el-tabs>
				</div>
			</el-col>
		</el-row>

		<!-- 资质证书页 -->
		<div id="zzzsPage" v-if="activeName=='third'">
			<el-row style="margin-top: 15px;">
				<el-col :span="8" v-for="zzzs in zsList" :key="zzzs.recid" style="text-align: left;" class="col-gutter">
					<div>
						<div
							style="background-color: #FAFAFA;display: flex;justify-content: center;align-items: center; ">
							<el-image v-if="ifImage(zzzs.srcList)" style="width: 150px; height: 150px;"
								:src="getImgUrl(zzzs.srcList[0])" :preview-src-list="getImgsByUrl(zzzs.srcList)">
							</el-image>
							<img v-else src="../../../../../assets/images/default.png" width="150px" height="150px" />
						</div>
						<div class="page-text" style="color: #333333;">证书名称：{{zzzs.zsName}}</div>
						<div class="page-text">获得日期：{{zzzs.zsDate}}</div>
						<div class="page-text" style="
							width: 250px;
							white-space:nowrap; 
							overflow: hidden;
							text-overflow: ellipsis;" :title="zzzs.bfDeptName">
							颁发单位：{{zzzs.bfDeptName}}
						</div>
					</div>
				</el-col>
			</el-row>
			<pagination v-show="zsTotal>0" :total="zsTotal" :page.sync="queryZsParams.pageNum"
				:limit.sync="queryZsParams.pageSize" :page-sizes="[9, 18, 27]" @pagination="getZsList()" />
		</div>


		<!-- 检测能力页 -->
		<div style="padding: 0 15px 0;" id="jcnlPage" v-if="activeName=='first'">
			<el-row class="right-box-select">
				<div>
					搜索查询:
					<el-input v-model="queryJcnlParams.dlName" placeholder="请输入检测能力产品名称或标准编号或标准名称" clearable
						size="small" style="width: 400px;padding: 0 10px 0 10px;" />
					<el-button type="primary" style="margin-top: 2px" size="small" @click="getJcnlList">检 索</el-button>
				</div>
			</el-row>
			<el-row style="margin-top: 15px;text-align: left;background-color:#FAFAFA;" v-for="jcnl in jcnlList"
				:key="jcnl.recid">
				<el-row class="page-text" style="color: #333333;">
					产品名称：{{jcnl.dlName}} / {{jcnl.categoryName}} / {{jcnl.subCategoryName}}
				</el-row>
				<el-row class="page-text">
					<el-col :span="8" :title="jcnl.methodCode" style="
						white-space:nowrap; 
						overflow: hidden;
						text-overflow: ellipsis;">
						依据标准编号：{{jcnl.methodCode}}
					</el-col>
					<el-col :span="14" :title="jcnl.methodName" style="
						white-space:nowrap; 
						overflow: hidden;
						text-overflow: ellipsis;">
						依据标准名称：{{jcnl.methodName}}
					</el-col>
					<el-col :span="2">
						<el-button size="mini" type="text" @click="showDeatil(jcnl)">
							详情
						</el-button>
					</el-col>
				</el-row>
			</el-row>
			<pagination v-show="jcnlTotal>0" :total="jcnlTotal" :page.sync="queryJcnlParams.pageNum"
				:limit.sync="queryJcnlParams.pageSize" @pagination="getJcnlList()" />
		</div>

		<!-- 设备页 -->
		<div style="padding: 0 15px 0;" id="sbPage" v-if="activeName=='second'">
			<el-row class="right-box-select">
				<div>
					搜索查询:
					<el-input v-model="querySbParams.deviceName" placeholder="请输入设备名称或描述" clearable size="small"
						style="width: 400px;padding: 0 10px 0 10px;" />
					<el-button type="primary" style="margin-top: 2px" size="small" @click="getSbList">检 索</el-button>
				</div>
			</el-row>
			<el-row style="margin-top: 20px;" id="zzzsPage" v-for="glsb in sbList" :key="glsb.recid">
				<el-col :span="4" style="height: 120px;text-align: left;background-color: #FAFAFA;">
					<el-image v-if="ifImage(glsb.srcList)" style="width: 140px; height: 100%"
						:src="getImgUrl(glsb.srcList[0])" :preview-src-list="getImgsByUrl(glsb.srcList)">
					</el-image>
					<img v-else src="../../../../../assets/images/default.png" width="140px" height=" 100% " />
				</el-col>
				<el-col :span="20" style="text-align: left;background-color: #FAFAFA;height: 120px;">
					<div style="height: 80px;">
						<div class="page-text" style="padding-top: 30px;color: #333333;font-size: 8pt;">
							设备名称：{{glsb.deviceName}}</div>
						<div class="page-text" style="padding-top: 20px;color: #666666;font-size: 7pt;
							width: 750px;
							white-space:nowrap; 
							overflow: hidden;
							text-overflow: ellipsis;" :title="glsb.deviceContent">
							设备描述：{{glsb.deviceContent}}
						</div>
					</div>
				</el-col>
			</el-row>
			<pagination v-show="sbTotal>0" :total="sbTotal" :page.sync="querySbParams.pageNum"
				:limit.sync="querySbParams.pageSize" :page-sizes="[10, 5, 20 , 50]" @pagination="getSbList()" />
		</div>

		<el-dialog :title="jcnlRowTitle" :visible.sync="jcnlRowOpen" width="60%" :close-on-click-modal="false">
			<el-descriptions class="margin-top" :column="2" border :contentStyle="CS" :labelStyle="LS">
				<el-descriptions-item>
					<template slot="label">大类序号</template>
					{{this.rowJcnl.dlType}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">大类名称</template>
					{{this.rowJcnl.dlName}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">类别序号</template>
					{{this.rowJcnl.categoryType}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">类别名称</template>
					{{this.rowJcnl.categoryName}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">产品/项目/参数-序号</template>
					{{this.rowJcnl.subCategoryType}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">产品/项目/参数-名称</template>
					{{this.rowJcnl.subCategoryName}}
				</el-descriptions-item>
				<el-descriptions-item :span="2">
					<template slot="label">依据标准编号</template>
					{{this.rowJcnl.methodCode}}
				</el-descriptions-item>
				<el-descriptions-item :span="2">
					<template slot="label">依据标准名称</template>
					{{this.rowJcnl.methodName}}
				</el-descriptions-item>
				<el-descriptions-item :span="2">
					<template slot="label">限制范围</template>
					{{this.rowJcnl.limitScope}}
				</el-descriptions-item>
				<el-descriptions-item :span="2">
					<template slot="label">说明</template>
					{{this.rowJcnl.illustrateDetail}}
				</el-descriptions-item>
			</el-descriptions>
		</el-dialog>


		<el-dialog :title="xmTitle" :visible.sync="xmOpen" width="500px" append-to-body :close-on-click-modal="false">
			<el-row>
				{{this.xmDetailContent}}
			</el-row>
		</el-dialog>

	</div>
</template>

<script>
	import {
		listJyzz,
		listZs,
		listJcnl,
		listSb,
	} from "@/api/zlts/ylqxcx/jyzz";
	import {
		updatePvNum,
		getPv
	} from "@/api/itempv/pv";
	import AttachmentListSize from "../../../../components/AttachmentListSize";
	export default {
		name: "Ylqxcx-Jyzz",
		props: {
			tableTitle: {
				type: String,
				required: true
			},
		},
		data() {
			return {
				activeName: 'first',
				// 遮罩层
				loading: true,
				//是否显示联系方式
				isShow: false,
				// 检验资质表格数据
				jyzzList: [],
				// 项目数据表
				jcnlList: [],
				// 设备数据表
				sbList: [],
				// 证书数据表
				zsList: [],
				// 检验资质 条数
				jyzzTotal: 0,
				// 设备 条数
				sbTotal: 0,
				// 项目 条数
				jcnlTotal: 0,
				// 证书 条数
				zsTotal: 0,
				// 检验资质查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					jyzxName: undefined,
					jyzxContent: undefined,
					updateTime: undefined,
					ywSaveStatus: undefined,
					deptAddr: undefined,
					contact: undefined,
				},
				//证书查询参数
				queryZsParams: {
					pageNum: 1,
					pageSize: 9,
					ywZltsYlqxcxJyzzRecid: undefined,
					zsName: undefined,
					zsDate: undefined,
					bfDeptName: undefined,
					srcList: [],
				},
				//项目查询参数
				queryJcnlParams: {
					pageNum: 1,
					pageSize: 10,
					dlType: undefined,
					dlName: undefined,
					categoryType: undefined,
					categoryName: undefined,
					subCategoryType: undefined,
					subCategoryName: undefined,
					methodName: undefined,
					methodCode: undefined,
					limitScope: undefined,
					illustrateDetail: undefined,
					createTime: undefined,
				},
				//设备查询参数
				querySbParams: {
					pageNum: 1,
					pageSize: 10,
					ywZltsYlqxcxJyzzRecid: undefined,
					deviceName: undefined,
					deviceContent: undefined,
					deviceImg: undefined,
					createTime: undefined,
					srcList: undefined,
				},
				//是否显示项目弹出层
				xmOpen: false,
				//项目弹出层标题
				xmTitle: "",
				//检验项目详情
				xmDetailContent: "",
				// 当前行检测能力
				rowJcnl: {
					dlType: undefined,
					dlName: undefined,
					categoryType: undefined,
					categoryName: undefined,
					subCategoryType: undefined,
					subCategoryName: undefined,
					methodName: undefined,
					methodCode: undefined,
					limitScope: undefined,
					illustrateDetail: undefined,
					createTime: undefined,
				},
				// 当前行检测能力详情弹出层
				jcnlRowOpen: false,
				// 当前行检测能力标题
				jcnlRowTitle: "",
				// contentStyle统一设置
				CS: {
					'min-width': '250px', //最小宽度
					'word-break': 'break-all' //过长时自动换行
				},
				// labelStyle统一设置
				LS: {
					'text-align': 'center',
					'min-width': '50px',
					'word-break': 'keep-all'
				},
				pv:{
					clickNum:undefined,
				},

			}

		},
		created() {
			this.getJyzzList();
			this.getSbList();
			this.getJcnlList();
			this.getZsList();
			// 检验当前登陆用户
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			// console.log(this.loginUser)
			if (this.loginUser != null && this.loginUser != undefined) {
				this.isShow = true;
			}
			updatePvNum("zlts_ylqxcx_jyzz").then(response => {
				//pv 点击检验资质
			});
			this.getPvJbxx();
		},
		methods: {
			getPvJbxx(){
				// 获取pv点击量
				getPv("zlts_ylqxcx_jyzz").then(response => {
					this.pv = response;
				});
			},
			/** 获取检验资质列表 **/
			getJyzzList() {
				listJyzz(this.queryParams).then(response => {
					this.jyzzList = response.rows;
					this.jyzzTotal = response.total;
				});
			},
			/** 查询证书列表 */
			getZsList() {
			 listZs(this.queryZsParams).then(response => {
					this.zsList = response.rows;
					this.zsTotal = response.total;
					// console.log(this.zsList)
				});
			},
			/** 查询设备列表 */
			getSbList() {
				listSb(this.querySbParams).then(response => {
			  this.sbList = response.rows;
					this.sbTotal = response.total;
				});
			},
			/** 查询检测能力列表 */
			getJcnlList() {
				listJcnl(this.queryJcnlParams).then(response => {
					this.jcnlList = response.rows;
					this.jcnlTotal = response.total;
					// console.log(this.jcnlList)
				});
			},
			//判断图片是否存在
			ifImage(imgList) {
				if (imgList == null || imgList == undefined || imgList.length <= 0) {
					return false;
				}
				return true;
			},
			// 预览图片获取图片数组
			getImgsByUrl(imgList) {
				if (imgList != null && imgList.length > 0) {
					let imgs = [];
					for (let i = 0; i < imgList.length; i++) {
						imgs.push(this.getImgUrl(imgList[i]));
					}
					return imgs;
				} else {
					return null;
				}
			},
			//判断是否存在附件？true：false
			ifDown(sysAttachments) {
				if (sysAttachments == null || sysAttachments == undefined || sysAttachments.length <= 0) {
					return false;
				}
				return true;
			},
			//下载附件
			handleDownload(file) {
				var name = file.fileName;
				var url = file.path;
				const a = document.createElement('a');
				a.setAttribute('download', name);
				a.setAttribute('target', '_blank');
				a.setAttribute('href', process.env.VUE_APP_BASE_API + url);
				a.click();
			},
			//查看检测能力详情数据
			showDeatil(row) {
				this.rowJcnl = {};
				// console.log(row)
				this.rowJcnl = row;
				this.jcnlRowOpen = true;
				this.jcnlRowTitle = "检测能力详情";
			},
			handleClick(tab, event) {
				// console.log(tab, event);
				// console.log(">>>>>>>"+this.activeName, tab.name);
			}
		}
	}
</script>

<style scoped>
	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}

	.right-box-select {
		padding: 15px 0;
		text-align: left;
		color: #333333;
		font-size: 15px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}

	.right-box-row {
		min-height: 200px;
		border: 1px solid #d2d2d2;
		padding: 0 15px 10px;
	}

	/* el-col间隔 */
	.col-gutter {
		padding: 0 15px 10px;
	}

	/* 每个模块文字显示位置 */
	.page-text {
		padding: 5px 10px;
		text-align: left;
		font-size: 0.66rem;
		color: #6d737b;
	}

	/* 下载附件按钮颜色 */
	.down-blue {
		cursor: pointer;
		color: #409eff;
		margin-top: 1rem;
	}

	.down-grey {
		cursor: pointer;
		color: #d2d2d2;
		margin-top: 1rem;
	}

	/* 联系人、单位地址图片大小 */
	.image {
		display: block;
		width: 18px;
		height: 18px;
	}

	/* 图片当前行展示 */
	.style-text {
		margin-top: 10px;
		display: flex;
		justify-content: flex-start;
	}

	/deep/ .el-tabs__nav-wrap:after {
		width: 98.5%;
	}
</style>
